module.exports = __webpack_public_path__ + "img/module-bg.e7f8271c.jpg";